import type { Sx } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import React, { type CSSProperties } from 'react';
import 'dayjs/locale/pl';
import { addYears, subYears } from 'date-fns';

type Props = {
  placeholder: string;
  label: string;
  value: Date | null;
  style: CSSProperties;
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onChange: (value: Date | null) => void;
  maxYearDelta?: number;
  minYearDelta?: number;
  sx: Sx;
};

export const DatePickerSingleInput = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      placeholder,
      label,
      value,
      style,
      size,
      onChange,
      maxYearDelta,
      minYearDelta,
      sx,
      ...rest
    },
    ref,
  ) => {
    const minDate =
      minYearDelta !== undefined && minYearDelta !== null
        ? subYears(new Date(), minYearDelta)
        : undefined;

    const maxDate =
      maxYearDelta !== undefined && maxYearDelta !== null
        ? addYears(new Date(), maxYearDelta)
        : undefined;

    return (
      <DatePicker
        ref={ref}
        withinPortal
        locale="pl"
        maxDate={maxDate}
        minDate={minDate}
        {...rest}
      />
    );
  },
);
